<template>
  <div>
    <h1 class="text-h3 text-sm-h2 text-md-h1 font-weight-bold">
      We Build Software Teams, Not Just Software.
    </h1>
    <p class="text-h5 text-sm-h4 text-white mt-6 mt-sm-10">
      People Over Process, Results Over Rituals
    </p>
    <v-btn
      class="mt-6"
      color="primary"
      to="/solutions"
      size="large"
      min-height="48"
      @click="scrollToTop"
    >
      Learn More
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'TeamworkSlide',
  methods: {
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 50);
    }
  }
};
</script>

<style scoped>
</style>
